exports.components = {
  "component---src-templates-custom-homepage-template-js": () => import("./../../../src/templates/custom/HomepageTemplate.js" /* webpackChunkName: "component---src-templates-custom-homepage-template-js" */),
  "component---src-templates-general-post-js": () => import("./../../../src/templates/general/Post.js" /* webpackChunkName: "component---src-templates-general-post-js" */)
}

